import { render, staticRenderFns } from "./NgNumberKeyboard.vue?vue&type=template&id=352f8f7c"
import script from "./NgNumberKeyboard.vue?vue&type=script&lang=js"
export * from "./NgNumberKeyboard.vue?vue&type=script&lang=js"
import style0 from "./NgNumberKeyboard.vue?vue&type=style&index=0&id=352f8f7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports